import { commonUtils } from '@/helpers/commonUtils'
import styles from './PptPageEnd.module.less'
import { useTranslation } from 'react-i18next'
import PptPage, { PageHeader } from '../PptPage/PptPage'
import { SliderModels } from '@/types/slider'
import { useEffect, useRef, useState } from 'react'
import AiTip from '@/components/AiTip/AiTip'
import { INTERNAL_HOST } from '@/commonConst'

interface Props {
  project: ProjectModels.ProjectDetail
  onSliderReady: (slider: SliderModels.Slider, no: number) => void
  no: number
}

function PdfPageEnd({ project, no, onSliderReady }: Props) {
  const { t, i18n } = useTranslation()
  const isJapanese = (i18n.resolvedLanguage || i18n.language || '')
    .toLowerCase()
    .startsWith('ja')
  const [basicSlider, setBasicSlider] = useState<SliderModels.Slider>()
  const [elements, setElements] = useState<SliderModels.PPTElement[]>([])
  const [pageHeaderElements, setPageHeaderElements] = useState<SliderModels.PPTElement[]>([])
  const [pageRect, setPageRect] = useState<DOMRect>()

  const lineRef = useRef<HTMLDivElement>(null)
  const endTitle = useRef<HTMLSpanElement>(null)
  const thankYouTitle = useRef<HTMLSpanElement>(null)
  const nextImg = useRef<HTMLImageElement>(null)
  const aiTipRef = useRef<HTMLDivElement>(null)

  const onPageRender = (slider: SliderModels.Slider, pageRect: DOMRect) => {
    setBasicSlider(slider)
    setPageRect(pageRect)
  }
  const onPageHeaderRender = (elements: SliderModels.PPTElement[]) => {
    setPageHeaderElements(elements)
  }

  useEffect(() => {
    if (!pageRect || !basicSlider || pageHeaderElements.length === 0 || elements.length === 0) {
      return
    }
    const _pageHeaderElements = pageHeaderElements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })

    const _elements = elements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })
    const slider: SliderModels.Slider = {
      ...basicSlider,
      elements: [..._pageHeaderElements, ...basicSlider.elements, ..._elements],
    }
    onSliderReady(slider, no)

  }, [pageRect, basicSlider, pageHeaderElements, elements])

  useEffect(() => {
    if (!endTitle.current || !thankYouTitle.current || !lineRef.current || !nextImg.current || !aiTipRef.current) {
      return
    }

    const endTitleRect = endTitle.current.getBoundingClientRect()
    const thankYouTitleRect = thankYouTitle.current.getBoundingClientRect()
    const thankYouTitleContainerRect = thankYouTitle.current.parentElement?.getBoundingClientRect()
    const nextImgRect = nextImg.current.getBoundingClientRect()
    const lineRect = lineRef.current.getBoundingClientRect()
    const aiTipRect = aiTipRef.current.getBoundingClientRect()
    console.log(aiTipRect)
    const elements: SliderModels.PPTElement[] = [
      {
        type: 'line',
        start: [0, 0],
        end: [lineRect.width, 0],
        style: 'solid',
        color: '#2A2C3F',
        x: lineRect.left,
        y: lineRect.top + 50,
        width: lineRect.height,
        points: ['', ''],
      },
      {
        type: 'text',
        content: endTitle.current.outerHTML,
        x: endTitleRect.left,
        y: endTitleRect.top,
        width: endTitleRect.width,
        height: endTitleRect.height,
      },
      {
        type: 'text',
        content: thankYouTitle.current.outerHTML,
        x: thankYouTitleRect.left,
        y: thankYouTitleRect.top,
        width: isJapanese
          ? thankYouTitleContainerRect?.width ?? thankYouTitleRect.width
          : thankYouTitleRect.width,
        height: thankYouTitleRect.height,
      },
      {
        type: 'image',
        src: commonUtils.getImagePath('PDFDownload/back.png'),
        x: nextImgRect.left,
        y: nextImgRect.top,
        width: nextImgRect.width,
        height: nextImgRect.height,
      },
    ]
    /** 国内域名显示AI提示 */
    if (INTERNAL_HOST.includes(location.hostname)) {
      elements.push({
        type: 'text',
        content: aiTipRef.current.outerHTML,
        x: aiTipRect.left + 50,
        y: aiTipRect.top - 30,
        width: aiTipRect.width,
        height: aiTipRect.height,
      })
    }
    setElements(elements)
  }, [])

  return (
    <PptPage
      bgSrc={commonUtils.getImagePath('PPTDownload/bg-1.jpg')}
      no={no}
      onPageRender={onPageRender}
    >
      <div className={styles.pptPageEnd}>
        <PageHeader project={project} onRender={onPageHeaderRender} />
        <div className={styles.briefLine} ref={lineRef}></div>
        <p className={styles.title}>
          <span ref={endTitle} style={{ color: '#2a2c3f', fontSize: 100, fontWeight: 'bold' }}>{t('dashboard.pdf.theEnd')}</span>
        </p>
        <p className={styles.title}>
          <span
            ref={thankYouTitle}
            style={{
              color: '#2a2c3f',
              fontSize: 100,
              fontWeight: 'bold',
              whiteSpace: isJapanese ? 'nowrap' : undefined,
            }}
          >
            {t('dashboard.pdf.thankYouForWatching')}
          </span>
        </p>

        <img
          ref={nextImg}
          style={{ width: 100, height: 100 }}
          className={styles.next}
          src={commonUtils.getImagePath('PDFDownload/back.png')}
          alt=''
        />
        <AiTip ref={aiTipRef} style={{ marginTop: 400, marginLeft: 100, fontSize: 20 }} />
      </div>
    </PptPage>
  )
}

export default PdfPageEnd
